// extracted by mini-css-extract-plugin
export default {"roboto":"GUF4GS7Q","authenticationInput":"XsrWhnNH"};